export default __webpack_public_path__ + "static/media/ic (1).4d607235.svg";